import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { LOGO_URL } from "@/constants/network";

const SEEN_KEY = "fsc-splash-seen";
const OVERLAY_ANIM = { exit: { opacity: 0 }, transition: { duration: 0.45 } };
const PERSPECTIVE = { perspective: 800 };
const LOGO_ANIM = { initial: { rotateY: 0, scale: 0.6, opacity: 0 }, animate: { rotateY: 720, scale: 1, opacity: 1 }, transition: { duration: 1.4, ease: [0.22, 1, 0.36, 1] } };
const TITLE_ANIM = { initial: { opacity: 0, y: 10 }, animate: { opacity: 1, y: 0 }, transition: { delay: 0.8, duration: 0.5 } };

export const SplashIntro = () => {
  const [show, setShow] = useState(() => !sessionStorage.getItem(SEEN_KEY));

  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem(SEEN_KEY, "1");
    const t = setTimeout(() => setShow(false), 1900);
    return () => clearTimeout(t);
  }, [show]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          data-testid="splash-intro"
          onClick={() => setShow(false)}
          className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-[#050505] cursor-pointer"
          {...OVERLAY_ANIM}
        >
          <div className="absolute w-72 h-72 rounded-full bg-[#D4AF37]/15 blur-3xl" />
          <div style={PERSPECTIVE}>
            <motion.img
              src={LOGO_URL}
              alt="FMI Smart Chain"
              className="relative w-36 h-36 sm:w-44 sm:h-44 rounded-full drop-shadow-[0_0_40px_rgba(212,175,55,0.45)]"
              {...LOGO_ANIM}
            />
          </div>
          <motion.p
            className="relative mt-6 font-display text-lg tracking-[0.3em] uppercase text-[#D4AF37]"
            {...TITLE_ANIM}
          >
            FMI Smart Chain
          </motion.p>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
